export function censorEmail(email: string): string {
  const [localPart, domain] = email.split("@");
  if (localPart.length <= 2) {
    return `***@${domain}`;
  }

  const censoredMiddle = "*".repeat(5);
  return `${censoredMiddle}@${domain}`;
}
